var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#2DFBB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13H25C26.1046 13 27 13.8954 27 15V23C27 24.1046 26.1046 25 25 25H13C11.8954 25 11 24.1046 11 23V15C11 13.8954 11.8954 13 13 13ZM9 15C9 12.7909 10.7909 11 13 11H25C27.2091 11 29 12.7909 29 15V23C29 25.2091 27.2091 27 25 27H13C10.7909 27 9 25.2091 9 23V15ZM14.6247 15.2191C14.1934 14.8741 13.5641 14.944 13.2191 15.3753C12.8741 15.8066 12.944 16.4359 13.3753 16.7809L17.1259 19.7814C18.2216 20.6579 19.7784 20.6579 20.8741 19.7814L24.6247 16.7809C25.056 16.4359 25.1259 15.8066 24.7809 15.3753C24.4359 14.944 23.8066 14.8741 23.3753 15.2191L19.6247 18.2196C19.2595 18.5118 18.7405 18.5118 18.3753 18.2196L14.6247 15.2191Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.40f8fa6fe5fde7c6eb7d0bae37ca95bf.svg";
export { ForwardRef as ReactComponent };